module.exports = __webpack_public_path__ + "media/images/login/app_bana-e521564e9833303fb248c54cd5c5be8b.png";